export default __webpack_public_path__ + "43d73b186139c34989ca8c39d56fc44d.png";